import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {IProduct} from "../models/IProduct";
import {BottomNavigation, BottomNavigationAction} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import {EnumHelper} from "../../../libraries/util/EnumHelper";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 700,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 2,
};

export function ProductModal(props: { product: IProduct | undefined }) {
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	
	return (
		<div>
			<Button onClick={handleOpen}>{props.product?.externalId}</Button>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			
			>
				<Box sx={style}>
					<Typography id="modal-modal-title">
						{props.product?.krn ?? ""}
					</Typography>
					{props.product &&
						<Typography id="modal-modal-description" sx={{mt: 2}}>
							{props.product.name}
						</Typography>
						
					}
					{props.product &&
						<Typography id="modal-modal-description" sx={{mt: 2}}>
							{EnumHelper.normalizeHotchocolateEnum(props.product.state)}
						</Typography>
						
					}
					<BottomNavigation
						showLabels
						onChange={(event, newValue) => {
							handleClose();
						}}
					>
						<BottomNavigationAction onClick={handleClose} icon={<CancelIcon/>}/>
					</BottomNavigation>
				</Box>
			</Modal>
		</div>
	);
}
